/*
 * Copyright (c) 2024.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Maxim Krupin <mkrupin@compo.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface Brand {
  id?: number;
  header: string;
  syncUid: string;
  enabled: boolean;
  deleted?: boolean;
}
